import { AnyAction } from '@reduxjs/toolkit';
import { NotificationsService } from 'modules/Notification/service';
import { toast } from 'react-toastify';
import { all, getContext, put, takeEvery } from 'redux-saga/effects';
import {
	addNotification,
	addNotificationFailure,
	addNotificationSuccess,
	deleteNotification,
	deleteNotificationFailure,
	deleteNotificationSuccess,
	getAllNotifications,
	getAllNotificationsFailure,
	getAllNotificationsSuccess,
	getNotificationToUpdate,
	getNotificationToUpdateFailure,
	getNotificationToUpdateSuccess,
	searchUsersQuestionsAnswers,
	setSearchUsersQuestionsAnswersResult,
	updateNotification,
	updateNotificationFailure,
	updateNotificationSuccess,
} from './slice';

function* getAllNotificationsListHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const notificationService = new NotificationsService(
			globalApplicationContext,
		);
		const data = yield notificationService.getAllNotifications(
			action.payload.page,
		);
		yield put(getAllNotificationsSuccess(data));
	} catch (e) {
		yield put(getAllNotificationsFailure(e));
		console.error(e);
	}
}

function* deleteNotificationHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const notificationService = new NotificationsService(
			globalApplicationContext,
		);
		yield notificationService.deleteNotification(action.payload.notificationId);
		yield put(deleteNotificationSuccess({}));
		toast('Notification deleted successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(deleteNotificationFailure(e));
		console.error(e);
	}
}

function* addNotificationHandler(action: AnyAction): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const notificationService = new NotificationsService(
			globalApplicationContext,
		);
		yield notificationService.addNotification(action.payload);
		yield put(addNotificationSuccess({}));
		toast('Notification created successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(addNotificationFailure({}));
	}
}

function* getNotificationToUpdateHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const notificationService = new NotificationsService(
			globalApplicationContext,
		);
		const data = yield notificationService.getNotificationById(
			action.payload.notificationId,
		);
		yield put(getNotificationToUpdateSuccess(data));
	} catch (e) {
		yield put(getNotificationToUpdateFailure({}));
	}
}

function* updateNotificationHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const notificationService = new NotificationsService(
			globalApplicationContext,
		);
		yield notificationService.updateNotification(action.payload);
		yield put(updateNotificationSuccess({}));
		toast('Notification updated successfully', {
			type: 'success',
		});
	} catch (e) {
		yield put(updateNotificationFailure({}));
	}
}

function* searchUsersQuestionsAnswersHandler(
	action: AnyAction,
): Generator<any, any, any> {
	try {
		const globalApplicationContext = yield getContext('applicationContext');
		const service = new NotificationsService(globalApplicationContext);
		const data = yield service.searchUsersQuestionsAnswers(
			action.payload.searchKey,
		);
		yield put(setSearchUsersQuestionsAnswersResult(data));
	} catch (e) {
		console.error(e);
	}
}

export function* notificationsSaga(): Generator<any, any, any> {
	yield all([
		takeEvery(getAllNotifications, getAllNotificationsListHandler),
		takeEvery(deleteNotification, deleteNotificationHandler),
		takeEvery(addNotification, addNotificationHandler),
		takeEvery(getNotificationToUpdate, getNotificationToUpdateHandler),
		takeEvery(updateNotification, updateNotificationHandler),
		takeEvery(searchUsersQuestionsAnswers, searchUsersQuestionsAnswersHandler),
	]);
}
